module.exports = __webpack_public_path__ + "img/DeepCleaningOfCarpetsUpholsteryAblutionsCanteensFloors.0222e8b7.jpg";